import React from 'react';
import { connect } from 'react-redux';
import { log } from 'util';
import { gtmEventPush, gtmPagePush } from '../../modules/ga/GTMdatalayer';
import FloatingInput from './floating-input';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import screen from '../../refresh/constants/pageType.constant';
import luxeScreen from '../../refresh/constants/luxeScreenType';

const { defaultStore } = luxeScreen;
class OTPComponent extends React.Component {
  constructor(props) {
    super(props);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      otp: '',
      secondsRemaining: 60,
      enableResendOTP: false,
      errorMsg: this.props.errorMsg
    };
    this.local = {
      timeout: ''
    };
    this.props.onRef && this.props.onRef(this);
  }

  _decrease(secLeft) {
    let timer = secLeft || this.state.secondsRemaining;
    if (timer > 0 && !this.state.errorMsg) {
      this.setState({ secondsRemaining: timer - 1 });
      this.local.timeout = setTimeout(this._decrease.bind(this), 1000);
    } else {
      this.local.timeout && clearTimeout(this.local.timeout);
      this.setState({ enableResendOTP: true });
    }
  }

  componentDidMount() {
    this._decrease();
    const { storeName, pageType } = this.props;
    let pageTypeOTP = '';
    let pageNameOTP = '';
    if (pageType == 'signup') {
      pageTypeOTP = screen?.signup_otp?.pageType;
      pageNameOTP = screen?.signup_otp?.pageName;
    } else {
      pageTypeOTP = screen?.login_otp?.pageType;
      pageNameOTP = screen?.login_otp?.pageName;
    }
    gtmPagePush(pageNameOTP, pageTypeOTP, window.__ENV__ || '', {
      store: storeName || defaultStore
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMsg !== this.props.errorMsg) this.setState({ errorMsg: nextProps.errorMsg });
  }

  componentWillUnmount() {
    this.local.timeout && clearTimeout(this.local.timeout);
    this.props.onRef && this.props.onRef(undefined);
    // _decrease(-1);
  }

  sendOTPtoProceed = e => {
    const { newDesignLuxe } = this.props;
    this.setState({
      otp: e.target.value
    });
    var otpRecvd = newDesignLuxe ? e.target.value : this.refs.otpRecvd.value;
    this.props.getOTP(otpRecvd);
  };

  resetOTPTimer(value) {
    if (value != 'undefined') {
      this.setState({ secondsRemaining: value });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorMsg !== this.props.errorMsg && this.props.errorMsg !== '') {
      this.local.timeout && clearTimeout(this.local.timeout);
      this.resetOTPTimer(0);
      this.setState({ enableResendOTP: true });
    }
  }

  resendOTPtoProceed = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(
      {
        enableResendOTP: false,
        secondsRemaining: 59,
        otp: '',
        errorMsg: ''
      },
      e => {
        this.props.resendOTP(e);
        this._decrease();
      }
    );
    gtmEventPush({
      event: 'link_click',
      screen_type: `Sign up`,
      link_text: 'Resend Otp',
      user_login_step: 2,
      page_type: 'Sign up'
    });
    gtmEventPush({
      page_name: this.props.pageNameLoginOTP,
      page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'Resend OTP'
    });
  };

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;

    const { viewSiteAs = '' } = this.props;
    var extraOptnClass =
      viewSiteAs == 'desktop' ? 'input-extra-options-desktop' : 'input-extra-options';
    let errGAtxt = `Error - ${this.props.errorMsg}`;
    return (
      <div
        className="login-form"
        data-ga-event-category="Sign Up"
        data-ga-event-action="Welcome to AJIO"
        data-ga-event-label="Screen Launch"
      >
        {newDesignLuxe ? (
          <FloatingInput
            error={this.state.errorMsg}
            type="tel"
            ref="otpRecvd"
            name="otp"
            className="login-form-inputs"
            floatingText="Enter OTP"
            size="32"
            maxLength="6"
            autoFocus={false}
            autoComplete="off"
            value={this.state.otp}
            onChange={e => {
              this.sendOTPtoProceed(e);
            }}
            placeholder="   "
            tabIndex="1"
            required={true}
            ariaRequired={true}
          />
        ) : (
          <div>
            <input
              type="tel"
              ref="otpRecvd"
              name="otp"
              className="login-form-inputs"
              placeholder="Enter OTP"
              size="32"
              maxLength="6"
             // autoFocus
              required
              aria-required="true"
              autoComplete="off"
              value={this.state.otp}
              onChange={e => {
                this.sendOTPtoProceed(e);
              }}
              // tabIndex="1"
            />
          </div>
        )}

        {this.props.errorMsg ? (
          <div
            id="error-msg"
            className="error-msg"
            data-ga-event-category="Login"
            data-ga-event-action="Sign in with OTP"
            data-ga-event-label={errGAtxt}
            aria-live="polite"
          >
            {this.props.errorMsg}
          </div>
        ) : null}

        <div className="otp-timer">
          <span
            className={
              this.state.enableResendOTP
                ? `${extraOptnClass}`
                : `disable-state-login ${extraOptnClass}`
            }
            role="button"
            tabIndex={0}
            onClick={e => {
              this.resendOTPtoProceed(e);
            }}
            // tabIndex="2"
            aria-label={this.props.showTimer && this.state.secondsRemaining > 0 ? `Resend OTP in ${this.state.secondsRemaining} seconds` : 'Resend OTP'}
          >
            {this.props.showTimer && this.state.secondsRemaining > 0
              ? `Resend OTP in ${this.state.secondsRemaining}s`
              : 'Resend OTP'}
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { signUpReducer = {}, httpError = {}, flags = {} } = state;
  const { error = {} } = httpError;
  const { statusCode = 0, authSuccess = 0, otpStatusMessage = '' } = signUpReducer;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    flags,
    statusCode,
    authSuccess,
    otpStatusMessage,
    errorStatus: error.statusCode,
    storeName
  };
};

export default OTPComponent = connect(mapStateToProps, null)(OTPComponent);
